"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolParticipantCreditsBySourceToJSON = exports.CommunityPoolParticipantCreditsBySourceFromJSONTyped = exports.CommunityPoolParticipantCreditsBySourceFromJSON = void 0;
var runtime_1 = require("../runtime");
function CommunityPoolParticipantCreditsBySourceFromJSON(json) {
    return CommunityPoolParticipantCreditsBySourceFromJSONTyped(json, false);
}
exports.CommunityPoolParticipantCreditsBySourceFromJSON = CommunityPoolParticipantCreditsBySourceFromJSON;
function CommunityPoolParticipantCreditsBySourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inAppFuel': !(0, runtime_1.exists)(json, 'inAppFuel') ? undefined : json['inAppFuel'],
        'onChainFuel': !(0, runtime_1.exists)(json, 'onChainFuel') ? undefined : json['onChainFuel'],
        'industryPasses': !(0, runtime_1.exists)(json, 'industryPasses') ? undefined : json['industryPasses'],
    };
}
exports.CommunityPoolParticipantCreditsBySourceFromJSONTyped = CommunityPoolParticipantCreditsBySourceFromJSONTyped;
function CommunityPoolParticipantCreditsBySourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'inAppFuel': value.inAppFuel,
        'onChainFuel': value.onChainFuel,
        'industryPasses': value.industryPasses,
    };
}
exports.CommunityPoolParticipantCreditsBySourceToJSON = CommunityPoolParticipantCreditsBySourceToJSON;
